// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1xLvo","immages":"Header_immages__1Lxnf","title":"Header_title__2-IQm"};